// Glossaire Cayus : les mots soulignés dans les pages, avec leur définition en une phrase.
// `match` = les formes à repérer dans le texte (insensible à la casse), par langue.
export const GLOSSARY = [
  {
    key: "graph",
    match: { fr: ["Microsoft Graph"], en: ["Microsoft Graph"], es: ["Microsoft Graph"] },
    def: {
      fr: "La porte officielle de Microsoft 365 par laquelle Cayus lit le travail d'un manager qui a donné son accord.",
      en: "The official Microsoft 365 door Cayus uses to read the work of a manager who gave consent.",
      es: "La puerta oficial de Microsoft 365 por la que Cayus lee el trabajo de un manager que ha dado su consentimiento.",
    },
  },
  {
    key: "signal",
    match: { fr: ["signal"], en: ["signal"], es: ["señal"] },
    def: {
      fr: "Une trace de travail toute simple : une demande envoyée, une réunion tenue, une réponse donnée.",
      en: "One very simple trace of work: an ask sent, a meeting held, a reply given.",
      es: "Un rastro de trabajo muy simple: una petición enviada, una reunión celebrada, una respuesta dada.",
    },
  },
  {
    key: "ladder",
    match: { fr: ["Behaviour Ladder", "Behaviour Ladders"], en: ["Behaviour Ladder", "Behaviour Ladders"], es: ["Behaviour Ladder", "Behaviour Ladders"] },
    def: {
      fr: "L'une des six comportements de management que Cayus observe, comme demander clairement ou reconnaître le travail.",
      en: "One of the six management behaviours Cayus observes, such as asking clearly or recognising work.",
      es: "Uno de los seis comportamientos de gestión que Cayus observa, como pedir con claridad o reconocer el trabajo.",
    },
  },
  {
    key: "window",
    match: { fr: ["fenêtre"], en: ["window"], es: ["ventana"] },
    def: {
      fr: "Les huit dernières semaines de travail : la période sur laquelle Cayus regarde, qui avance avec le temps.",
      en: "The last eight weeks of work: the period Cayus looks at, which rolls forward over time.",
      es: "Las últimas ocho semanas de trabajo: el periodo que Cayus observa, que avanza con el tiempo.",
    },
  },
  {
    key: "baseline",
    match: { fr: ["point de départ"], en: ["baseline", "starting point"], es: ["punto de partida"] },
    def: {
      fr: "Le niveau du manager au début : il n'est comparé qu'à lui-même, jamais aux autres.",
      en: "The manager's own level at the start: they are only ever compared with themselves, never with others.",
      es: "El nivel del manager al principio: solo se compara consigo mismo, nunca con los demás.",
    },
  },
  {
    key: "mirror",
    match: { fr: ["Mirror"], en: ["Mirror"], es: ["Mirror"] },
    def: {
      fr: "La vue privée du manager : ni son patron, ni les RH, ni la direction ne la voient.",
      en: "The manager's private view: their boss, HR and leadership never see it.",
      es: "La vista privada del manager: ni su jefe, ni RRHH, ni la dirección la ven.",
    },
  },
  {
    key: "compass",
    match: { fr: ["Compass"], en: ["Compass"], es: ["Compass"] },
    def: {
      fr: "Ce que le manager travaille cette semaine : une ou deux choses concrètes, pas plus.",
      en: "What the manager works on this week: one or two concrete things, no more.",
      es: "Lo que el manager trabaja esta semana: una o dos cosas concretas, no más.",
    },
  },
  {
    key: "radar",
    match: { fr: ["Radar"], en: ["Radar"], es: ["Radar"] },
    def: {
      fr: "La vue d'ensemble de l'organisation : des groupes de huit personnes minimum, décrits avec des mots.",
      en: "The organisation-wide view: groups of eight people minimum, described in words.",
      es: "La vista de conjunto de la organización: grupos de ocho personas como mínimo, descritos con palabras.",
    },
  },
  {
    key: "building",
    match: { fr: ["Building Evidence"], en: ["Building Evidence"], es: ["Building Evidence"] },
    def: {
      fr: "Ce qui s'affiche quand il n'y a pas encore assez d'exemples pour se prononcer. Cayus préfère se taire.",
      en: "What is shown when there aren't enough examples yet to say anything. Cayus prefers to stay silent.",
      es: "Lo que se muestra cuando aún no hay suficientes ejemplos para opinar. Cayus prefiere callar.",
    },
  },
  {
    key: "wall",
    match: { fr: ["le mur", "du mur"], en: ["the wall"], es: ["el muro", "del muro"] },
    def: {
      fr: "La frontière entre ce que la machine calcule et ce qu'un humain lit. Aucun score, aucun nom, aucun message ne la traverse.",
      en: "The line between what the machine calculates and what a human reads. No score, no name and no message ever crosses it.",
      es: "La frontera entre lo que la máquina calcula y lo que lee una persona. Ninguna puntuación, ningún nombre y ningún mensaje la cruzan.",
    },
  },
  {
    key: "emerging",
    match: { fr: ["Emerging"], en: ["Emerging"], es: ["Emerging"] },
    def: {
      fr: "Première étape : le comportement apparaît, sans encore tenir dans le temps.",
      en: "First level: the behaviour appears, but doesn't hold over time yet.",
      es: "Primer nivel: el comportamiento aparece, pero aún no se sostiene en el tiempo.",
    },
  },
  {
    key: "establishing",
    match: { fr: ["Establishing"], en: ["Establishing"], es: ["Establishing"] },
    def: {
      fr: "Deuxième étape : le comportement revient souvent, il commence à s'installer.",
      en: "Second level: the behaviour comes back often and is starting to settle in.",
      es: "Segundo nivel: el comportamiento vuelve a menudo y empieza a instalarse.",
    },
  },
  {
    key: "consistent",
    match: { fr: ["Consistent"], en: ["Consistent"], es: ["Consistent"] },
    def: {
      fr: "Troisième étape : le comportement tient, semaine après semaine, sans y penser.",
      en: "Third level: the behaviour holds, week after week, without thinking about it.",
      es: "Tercer nivel: el comportamiento se sostiene, semana tras semana, sin pensarlo.",
    },
  },
  {
    key: "multiplying",
    match: { fr: ["Multiplying"], en: ["Multiplying"], es: ["Multiplying"] },
    def: {
      fr: "Quatrième étape : le comportement se transmet, l'équipe le reproduit sans le manager.",
      en: "Fourth level: the behaviour spreads, the team keeps it going without the manager.",
      es: "Cuarto nivel: el comportamiento se transmite, el equipo lo mantiene sin el manager.",
    },
  },
  {
    key: "kpi",
    match: { fr: ["KPIs", "KPI"], en: ["KPIs", "KPI"], es: ["KPIs", "KPI"] },
    def: {
      fr: "Les indicateurs que vous suivez déjà : chiffre d'affaires, délais, qualité. Ils disent le résultat, pas la manière de l'obtenir.",
      en: "The indicators you already follow: revenue, deadlines, quality. They tell you the result, not how it was reached.",
      es: "Los indicadores que ya sigue: facturación, plazos, calidad. Dicen el resultado, no la manera de lograrlo.",
    },
  },
  {
    key: "rgpd",
    match: { fr: ["RGPD"], en: ["GDPR"], es: ["RGPD"] },
    def: {
      fr: "La loi européenne sur les données personnelles : chacun sait ce qui est utilisé, pourquoi, et peut dire non.",
      en: "The European law on personal data: everyone knows what is used, why, and can say no.",
      es: "La ley europea de datos personales: cada uno sabe qué se usa, por qué, y puede decir no.",
    },
  },
  {
    key: "aiact",
    match: { fr: ["EU AI Act", "règlement européen sur l'IA"], en: ["EU AI Act"], es: ["EU AI Act", "Reglamento europeo de IA"] },
    def: {
      fr: "La loi européenne sur l'intelligence artificielle : elle interdit notamment de noter les gens à leur insu.",
      en: "The European law on artificial intelligence: among other things, it forbids grading people without their knowledge.",
      es: "La ley europea de inteligencia artificial: prohíbe, entre otras cosas, puntuar a las personas sin que lo sepan.",
    },
  },
  {
    key: "cse",
    match: { fr: ["CSE"], en: ["works council", "works councils"], es: ["comité de empresa"] },
    def: {
      fr: "Le comité social et économique : les représentants du personnel, que l'on consulte avant de mettre un outil comme Cayus en place.",
      en: "The staff representatives who are consulted before a tool like Cayus is put in place.",
      es: "Los representantes del personal, a quienes se consulta antes de implantar una herramienta como Cayus.",
    },
  },
  {
    key: "m365",
    match: { fr: ["Microsoft 365"], en: ["Microsoft 365"], es: ["Microsoft 365"] },
    def: {
      fr: "L'espace de travail Microsoft de votre entreprise (Teams, Outlook, calendrier). Cayus reste à l'intérieur, avec votre sécurité.",
      en: "Your company's Microsoft workspace (Teams, Outlook, calendar). Cayus stays inside it, behind your own security.",
      es: "El espacio de trabajo Microsoft de su empresa (Teams, Outlook, calendario). Cayus se queda dentro, con su propia seguridad.",
    },
  },
  {
    key: "teams",
    match: { fr: ["Microsoft Teams"], en: ["Microsoft Teams"], es: ["Microsoft Teams"] },
    def: {
      fr: "L'outil de discussion et de réunions de Microsoft, déjà ouvert toute la journée. Cayus y ajoute simplement un onglet.",
      en: "Microsoft's chat and meetings tool, already open all day. Cayus just adds a tab to it.",
      es: "La herramienta de conversación y reuniones de Microsoft, ya abierta todo el día. Cayus solo añade una pestaña.",
    },
  },
];

const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Construit une seule expression pour repérer tous les mots du glossaire dans une langue. */
export const buildGlossaryRegex = (language) => {
  const parts = [];
  GLOSSARY.forEach((term) => {
    (term.match[language] || term.match.fr).forEach((m) => parts.push({ m, key: term.key }));
  });
  parts.sort((a, b) => b.m.length - a.m.length);
  const pattern = parts.map((p) => escape(p.m)).join("|");
  return {
    regex: new RegExp(`(?<![\\p{L}])(${pattern})(?![\\p{L}])`, "giu"),
    lookup: parts.reduce((acc, p) => {
      acc[p.m.toLowerCase()] = p.key;
      return acc;
    }, {}),
  };
};

export const glossaryDefinition = (key, language) => {
  const term = GLOSSARY.find((t) => t.key === key);
  return term ? term.def[language] || term.def.fr : null;
};

export default GLOSSARY;
